document.addEventListener("DOMContentLoaded", () => {
  const newsContainers = document.querySelectorAll(".news-container");

  // Check screen width
  const isDesktop = () => window.innerWidth >= 1024;

  // Debounce function to limit resize event calls
  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  };

  // Function to expand a container
  const expandContainer = (container) => {
    // Collapse all other containers
    newsContainers.forEach((item) => {
      item.classList.remove("expanded");
      item.querySelector(".news-left").classList.remove("expanded");
      item.querySelector(".news-text").classList.remove("visible");
      item.querySelector(".news-button").classList.remove("expanded");
    });

    // Expand the target container
    container.classList.add("expanded");
    container.querySelector(".news-left").classList.add("expanded");
    container.querySelector(".news-text").classList.add("visible");
    container.querySelector(".news-button").classList.add("expanded");
  };

  // Remove hover and focus event listeners
  const removeEventListeners = () => {
    newsContainers.forEach((container) => {
      const clonedContainer = container.cloneNode(true);
      container.parentNode.replaceChild(clonedContainer, container);
    });
  };

  // Apply behavior based on screen width
  const applyBehavior = () => {
    if (isDesktop()) {
      // Get fresh references after potential cloning
      const currentContainers = document.querySelectorAll(".news-container");

      // Set center container as default expanded
      const centerIndex = Math.floor(currentContainers.length / 2);
      const centerContainer = currentContainers[centerIndex];
      expandContainer(centerContainer);

      currentContainers.forEach((container) => {
        // Mouse events
        container.addEventListener("mouseenter", () => {
          expandContainer(container);
        });

        // Focus events for keyboard navigation
        container.addEventListener("focus", () => {
          expandContainer(container);
        });

        // Handle focus on child elements (like the button)
        container.addEventListener("focusin", (e) => {
          expandContainer(container);
        });
      });
    } else {
      // Remove all hover and focus event listeners
      removeEventListeners();

      // Get fresh references after cloning
      const currentContainers = document.querySelectorAll(".news-container");

      // Apply expanded styles statically
      currentContainers.forEach((container) => {
        container.classList.add("expanded");
        container.querySelector(".news-left").classList.add("expanded");
        container.querySelector(".news-text").classList.add("visible");
        container.querySelector(".news-button").classList.add("expanded");
      });
    }
  };

  // Apply behavior on load
  applyBehavior();

  // Reapply behavior on resize with debounce
  window.addEventListener("resize", debounce(applyBehavior, 200));
});

// Rest of your carousel code...
document.addEventListener("DOMContentLoaded", () => {
  const carousel = document.querySelector(".carousel-container");
  const prevButton = document.querySelector(".prev-button-expertise");
  const nextButton = document.querySelector(".next-button-expertise");
  const cards = Array.from(document.querySelectorAll(".expertise-card"));

  let isScrolling = false;
  let currentIndex = 0;

  function enableCarousel() {
    // Prevent double initialization
    if (carousel.dataset.infiniteInitialized) return;
    carousel.dataset.infiniteInitialized = "true";

    // Clone cards for infinite scrolling
    cards.forEach((card) => {
      const clone = card.cloneNode(true);
      carousel.appendChild(clone);
    });
    cards.forEach((card) => {
      const clone = card.cloneNode(true);
      carousel.insertBefore(clone, carousel.firstChild);
    });

    // Calculate dimensions
    const getCardWidth = () => {
      const firstCard = carousel.querySelector(".expertise-card");
      if (!firstCard) return 0;
      const cardRect = firstCard.getBoundingClientRect();
      const gap = parseInt(getComputedStyle(carousel).gap || 0, 10);
      return cardRect.width + gap;
    };

    // Position initiale au centre sur les cartes originales
    const cardWidth = getCardWidth();
    currentIndex = cards.length;
    carousel.scrollLeft = cardWidth * currentIndex;

    // Button functionality
    const handlePrev = () => {
      if (isScrolling) return;
      isScrolling = true;

      currentIndex--;
      const scrollAmount = getCardWidth();

      carousel.scrollBy({
        left: -scrollAmount,
        behavior: "smooth",
      });

      setTimeout(() => {
        // Si on est au début des clones de gauche, repositionner à la fin des originaux
        if (currentIndex < cards.length) {
          const cardWidth = getCardWidth();
          currentIndex = cards.length * 2 - 1;
          carousel.scrollLeft = cardWidth * currentIndex;
        }
        isScrolling = false;
      }, 300);
    };

    const handleNext = () => {
      if (isScrolling) return;
      isScrolling = true;

      currentIndex++;
      const scrollAmount = getCardWidth();

      carousel.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });

      setTimeout(() => {
        // Si on est à la fin des clones de droite, repositionner au début des originaux
        if (currentIndex >= cards.length * 2) {
          const cardWidth = getCardWidth();
          currentIndex = cards.length;
          carousel.scrollLeft = cardWidth * currentIndex;
        }
        isScrolling = false;
      }, 300);
    };

    prevButton.addEventListener("click", handlePrev);
    nextButton.addEventListener("click", handleNext);

    // Recalculer lors du resize
    const handleResize = () => {
      if (carousel.dataset.infiniteInitialized && !isScrolling) {
        const cardWidth = getCardWidth();
        carousel.scrollLeft = cardWidth * currentIndex;
      }
    };

    window.addEventListener("resize", handleResize);
  }

  function disableCarousel() {
    // Only run if previously initialized
    if (!carousel.dataset.infiniteInitialized) return;
    carousel.dataset.infiniteInitialized = "";

    // Remove cloned cards
    const allCards = carousel.querySelectorAll(".expertise-card");
    // Remove all except the first set
    for (let i = allCards.length - 1; i >= cards.length; i--) {
      allCards[i].remove();
    }
    // Remove event listeners by cloning carousel node
    const newCarousel = carousel.cloneNode(true);
    carousel.parentNode.replaceChild(newCarousel, carousel);
  }

  function handleResize() {
    if (window.innerWidth < 1381) {
      enableCarousel();
    } else {
      disableCarousel();
    }
  }

  handleResize();
  window.addEventListener("resize", handleResize);
});

document.addEventListener("DOMContentLoaded", function () {
  // Récupérer dynamiquement tous les radio inputs du carrousel
  const radios = Array.from(
    document.querySelectorAll('input[name="carousel"]')
  );

  const dots = document.querySelectorAll(".carousel-dot");

  function updateDots() {
    radios.forEach((radio, idx) => {
      if (radio.checked) {
        dots[idx].classList.add("active");
      } else {
        dots[idx].classList.remove("active");
      }
    });
  }

  // Update on radio change
  radios.forEach((radio) => {
    radio.addEventListener("change", updateDots);
  });

  // Update on next/prev
  document
    .querySelector(".next-button")
    ?.addEventListener("click", function () {
      setTimeout(updateDots, 10);
    });
  document
    .querySelector(".prev-button")
    ?.addEventListener("click", function () {
      setTimeout(updateDots, 10);
    });

  // Initial state
  updateDots();

  let current = 0;
  let playing = true;
  let interval = null;

  function showSlide(index) {
    if (radios[index]) radios[index].checked = true;
    current = index;
    updateDots(); // <-- Add this line!
  }

  function nextSlide() {
    showSlide((current + 1) % radios.length);
  }

  function prevSlide() {
    showSlide((current - 1 + radios.length) % radios.length);
  }

  function play() {
    playing = true;
    interval = setInterval(nextSlide, 3000);
  }

  function pause() {
    playing = false;
    clearInterval(interval);
  }

  // Arrow controls (buttons now, not labels)
  const nextBtn = document.querySelector(".next-button");
  const prevBtn = document.querySelector(".prev-button");

  nextBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    pause();
    nextSlide();
  });

  prevBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    pause();
    prevSlide();
  });

  // Dots controls (labels linked to radio inputs)
  dots.forEach((dot, idx) => {
    dot.addEventListener("click", function () {
      pause();
      showSlide(idx);
    });
  });

  // Play/Pause button

  const pauseBtn = document.querySelector(".carousel-pause");
  const iconPause = pauseBtn?.querySelector(".icon-pause");
  const iconPlay = pauseBtn?.querySelector(".icon-play");

  function showPauseIcon() {
    if (iconPause) iconPause.style.display = "";
    if (iconPlay) iconPlay.style.display = "none";
    pauseBtn.setAttribute("aria-label", "Pause le carrousel");
  }
  function showPlayIcon() {
    if (iconPause) iconPause.style.display = "none";
    if (iconPlay) iconPlay.style.display = "";
    pauseBtn.setAttribute("aria-label", "Lire le carrousel");
  }

  if (pauseBtn) {
    pauseBtn.addEventListener("click", function () {
      if (playing) {
        pause();
        showPlayIcon();
      } else {
        play();
        showPauseIcon();
      }
    });
    // Init icon
    showPauseIcon();
  }

  // Start autoplay
  play();

  // Pause on manual interaction
  radios.forEach((radio, idx) => {
    radio.addEventListener("change", function () {
      pause();
      current = idx;
    });
  });
});
